import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CloseButton } from '../../elements/CloseButton';
import { SaveButton } from '../../elements/SaveButton';
function PreferencesHeader({ onClose, onSave }) {
    return (_jsxs("div", { style: {
            display: 'flex',
            flexDirection: 'row-reverse',
            borderBottom: '0.55px solid rgb(240 240 240)',
        }, children: [_jsx(CloseButton, { onClick: onClose, tooltip: "Close preferences" }), _jsx(SaveButton, { onClick: onSave, tooltip: "Save preferences" })] }));
}
export default PreferencesHeader;
